import { useApi } from '@shared/api'

export interface ProductSuggestionResponse {
  institution: { id: string; name: string }
  main_product: { id: string; name: string; category_id: string; category_name: string }
  suggestions: Array<{
    type: string
    category: string
    products: Array<{
      id: string
      name: string
      price: string
      img: string[]
      is_favorite: boolean
      category_id: string
    }>
  }>
}

/**
 * API-клиент рекомендаций и предложений продуктов.
 * Базовый URL: /api/v2
 */
class APIRecommendation {
  /**
   * Получить предложения для карточки продукта.
   * GET /api/v2/products/suggestions?product_id=&branch_id=
   */
  async getProductSuggestions(productId: number, branchId: number): Promise<ProductSuggestionResponse> {
    const response = await useApi(true).get<ProductSuggestionResponse>('/products/suggestions', {
      params: {
        product_id: String(productId),
        branch_id: String(branchId),
      },
    })
    return response.data
  }

  /**
   * Получить рекомендации на основе корзины.
   * GET /api/v2/recommendations?items=&branch_id=&limit=
   */
  async getBasketRecommendations(itemIds: number[], branchId: number, limit = 10): Promise<any[]> {
    if (itemIds.length === 0 || !branchId) return []

    const response = await useApi(true).get('/recommendations', {
      params: {
        items: itemIds.join(','),
        branch_id: branchId,
        limit,
      },
    })

    return response.data ?? []
  }
}

export const apiRecommendation = new APIRecommendation()
export default apiRecommendation
